module.exports = __webpack_public_path__ + "static/media/interactiveQa.51e24165.svg";